"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importWarehouseApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var importWarehouseApi = exports.importWarehouseApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/importWarehouse",
      params: params
    });
  },
  delete: function _delete(id) {
    return (0, _request.default)({
      url: "/importWarehouse/".concat(id, "/delete"),
      method: 'post'
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/importWarehouse",
      data: data,
      method: "post"
    });
  },
  addDetail: function addDetail(id, data) {
    return (0, _request.default)({
      url: "/importWarehouse/".concat(id, "/add/detail"),
      method: 'post',
      data: data
    });
  },
  deleteDetail: function deleteDetail(id) {
    return (0, _request.default)({
      url: "/importWarehouseDetail/".concat(id, "/delete"),
      method: 'post'
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/importWarehouse/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  },
  updateDetailQuantity: function updateDetailQuantity(id, data) {
    return (0, _request.default)({
      url: "/importWarehouseDetail/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  }
};